if($('.in-index').length){
    $('#products-2').after('<div class="text-center"><a href="'+buttonUrl+'" class="btn bt-default">'+buttonName+'</a></div>');
    $('.homepage-box .welcome').before($('.homepage-box .welcome>div>div'));


    $('.footer-banners.row.banner-wrapper').before($('.content-wrapper.homepage-box.welcome-wrapper'));
};